exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.signature div[data-v-255295b4]:first-child {\n    border: 1px solid;\n    padding: 0 !important;\n}\n.menu-signature[data-v-255295b4] {\n\n    /*float: right;*/\n    /*transform: translateY(-35px);*/\n}\n", ""]);

// exports
